import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import CompanyNameCombineModel from '../models/CompanyNameCombineModel';

interface CompanyNameCombineSearchState {
    searchResults: CompanyNameCombineModel[],
    datatableSelectedIndex: number,
    triggerRefreshData: number,
}

const initialState: CompanyNameCombineSearchState = {
    searchResults: [],
    datatableSelectedIndex: -1,
    triggerRefreshData: 0,
}

export const CompanyNameCombineSearchSlice = createSlice({
    name: "CompanyNameCombineSearch",
    initialState,
    reducers: {
        setSearchResults: (state, action: PayloadAction<CompanyNameCombineModel[]>) => {
            state.searchResults = action.payload;
        },
        setDatatableSelectedIndex: (state, action: PayloadAction<number>) => {
            state.datatableSelectedIndex = action.payload;
        },
        setTriggerRefreshData: (state, action: PayloadAction<number>) => {
            state.triggerRefreshData = action.payload;
        },
    }
});

export const CompanyNameCombineSearchSelector = createSelector(
    (state: RootState) => state.companyNameCombineSearch,
    (data) => data
);

export const {
    setSearchResults,
    setDatatableSelectedIndex,
    setTriggerRefreshData,
} = CompanyNameCombineSearchSlice.actions;

export default CompanyNameCombineSearchSlice.reducer;